import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'

export default function OAuthCallback() {
  const navigate = useNavigate()

  useEffect(() => {
    console.log('🔐 OAuthCallback: Iniciando processamento...')

    const cleanUrl = () => {
      try {
        const url = new URL(window.location.href)
        if (url.hash || url.search) {
          window.history.replaceState({}, document.title, url.pathname)
          console.log('🔐 URL limpa')
        }
      } catch (e) {
        console.warn('🔐 Falha ao limpar URL', e)
      }
    }

    const finalize = async () => {
      try {
        // Capturar erros que o Supabase devolve no query string ANTES de limpar a URL
        const callbackUrl = new URL(window.location.href)
        const urlError = callbackUrl.searchParams.get('error') || ''
        const urlErrorCode = callbackUrl.searchParams.get('error_code') || ''
        const urlErrorDescription = callbackUrl.searchParams.get('error_description') || ''
        console.log('🔐 Erro do Supabase:', { urlError, urlErrorCode, urlErrorDescription })

        // Verificar se há hash na URL (tokens OAuth)
        const hash = window.location.hash
        const hasAuthTokens = hash && (hash.includes('access_token') || hash.includes('error'))
        console.log('🔐 Hash na URL:', hash ? 'Sim' : 'Não', '| Tokens:', hasAuthTokens ? 'Sim' : 'Não')

        // Se há tokens na URL, o Supabase com detectSessionInUrl:true já tentou processar
        // Mas pode ter falhado, então vamos aguardar e verificar
        if (hasAuthTokens) {
          console.log('🔐 Aguardando Supabase processar tokens...')
          // Aguardar um momento para o Supabase processar
          await new Promise(r => setTimeout(r, 500))
        }

        // Tentar obter sessão
        const { data: { session }, error: sessionError } = await supabase.auth.getSession()
        console.log('🔐 Sessão:', session ? 'Encontrada' : 'Não encontrada', '| Erro:', sessionError)

        if (sessionError) {
          console.error('🔐 Erro na sessão:', sessionError)
        }

        // Limpar URL
        cleanUrl()

        if (session) {
          console.log('🔐 Sucesso! Redirecionando para dashboard')
          navigate('/dashboard', { replace: true })
          return
        }

        // Se não há sessão mas há tokens, pode ser erro de processamento
        if (hasAuthTokens) {
          console.log('🔐 Tokens presentes mas sem sessão. Tentando recuperar...')
          // Tentar mais uma vez após delay maior
          await new Promise(r => setTimeout(r, 1000))
          const { data: { session: retrySession } } = await supabase.auth.getSession()
          if (retrySession) {
            console.log('🔐 Sessão recuperada!')
            navigate('/dashboard', { replace: true })
            return
          }
        }

        // Falha - redirecionar para login (passar o erro real do Supabase, se houver)
        console.error('🔐 Falha no OAuth - sem sessão')
        if (urlErrorDescription || urlErrorCode || urlError) {
          const realError = urlErrorDescription || urlErrorCode || urlError
          navigate(`/login?error=${encodeURIComponent(realError)}`, { replace: true })
        } else {
          navigate('/login?error=oauth_failed', { replace: true })
        }
      } catch (e) {
        console.error('🔐 Erro crítico:', e)
        cleanUrl()
        navigate('/login?error=oauth_error', { replace: true })
      }
    }

    finalize()
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center text-slate-600">
        Processando login...
      </div>
    </div>
  )
}


